/*eslint-disable */
import React, { useState, useEffect, useRef } from "react";

interface GaleriaComponentProps {
  genuine_parts: any;
}
declare const window: any;
const GaleriaComponent: React.FC<GaleriaComponentProps> = ({
  genuine_parts,
}) => {
  const [currentIndex, setCurrentIndex] = useState(1);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    videoRefs.current.forEach((video, index) => {
      if (video) {
        if (index === currentIndex) {
          video.play();
        } else {
          video.pause();
        }
      }
    });
  }, [currentIndex]);

  useEffect(() => {
    const firstVideo = videoRefs.current[currentIndex];
    if (firstVideo) {
      firstVideo.play();
    }
  }, [currentIndex]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : genuine_parts?.carousel?.length - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < genuine_parts?.carousel?.length - 1 ? prevIndex + 1 : 0
    );
  };

  const extractYouTubeID = (url: any) => {
    const match = url.match(/(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)|youtu\.be\/([a-zA-Z0-9_-]+)/);
    return match ? (match[1] || match[2]) : null;
  };
  
  return (
    <div
      className="caracteristica-vehiculos-detail-component"
      style={{ backgroundColor: "#fff" }}
    >
      <div
        className="btn-carrousel-caracteristica-vehiculos-detail-component prev"
        onClick={handlePrev}
      >
        <img src="../assets/01_Home/Icon_Left.svg" alt="Ícono de flecha izquierda" />
      </div>
      <div
        className="carrousel-caracteristica-vehiculos-detail-component"
        style={{
          transform:
            currentIndex === 0
              ? `translateX(${windowWidth < 768 ? "10%" : "25%"})`
              : `translateX(-${
                  windowWidth < 768
                    ? currentIndex * 70 === 70
                      ? currentIndex * 70
                      : currentIndex * 80 - 10
                    : currentIndex * 25 === 25
                    ? currentIndex * 25
                    : currentIndex * 25 === 50
                    ? currentIndex * 25 + 25
                    : currentIndex * 50 + 25 - 50
                }%)`,
        }}
      >
        {genuine_parts?.carousel?.map((item: any, index: any) =>
          item?.url_youtube ? (
            <div
              className={`item-caracteristica-vehiculos-detail-component`}
              key={index}
            >
              <iframe
                src={`https://www.youtube.com/embed/${extractYouTubeID(
                  item?.url_youtube
                )}`}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              />
            </div>
          ) : null
        )}
      </div>
      <div
        className="btn-carrousel-caracteristica-vehiculos-detail-component next"
        onClick={handleNext}
      >
        <img src="../assets/01_Home/Icon_Right.svg" alt="Ícono de flecha derecha" />
      </div>
      <div
        className="info-caracteristica-vehiculos-detail-component"
        style={{ backgroundColor: "#fff", height: "50px" }}
      >
        <div className="index-caracteristica-vehiculos-detail-component">
          {genuine_parts?.carousel?.map((item: any, index: number) => (
            <div
              className={`${index === currentIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
              key={index}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GaleriaComponent;
